<template>
	<o-tour :ref="setup._tourNewNavigation">
		<o-tour-step
			hide-finish
			:closable="false"
			:title="$t('common.shared.tour.navigation.title')"
			target="tour-navigation">
			<p>
				{{ $t('common.shared.tour.navigation.description') }}
			</p>
			<p>
				{{ $t('common.shared.tour.navigation.favorites') }}<br>
				{{ $t('common.shared.tour.navigation.favoritesInstruction') }}
			</p>
		</o-tour-step>
		<o-tour-step
			hide-finish
			:closable="false"
			:title="$t('common.tour.navigation.profile.title')"
			target="navigation-tour-profile">
			<p>
				{{ $t('common.tour.navigation.profile.description') }}
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="!setup.responsive.onPhone"
			:title="$t('common.tour.navigation.logout.title')"
			target="navigation-tour-logout">
			<p>
				{{ $t('common.tour.navigation.logout.description') }}
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.responsive.onPhone"
			hide-finish
			:title="$t('common.tour.navigation.logout.title')"
			:closable="false"
			target="tour-navigation-menu"
			:next="setup.toggleMenu(true)">
			<p>{{ $t('common.tour.navigation.logout.phoneInstruction') }}</p>
		</o-tour-step>

		<o-tour-step
			v-if="setup.responsive.onPhone"
			:previous="setup.toggleMenu(false)"
			:title="$t('common.tour.navigation.logout.title')"
			:end="setup.toggleMenu(false)"
			target="tour-navigation-logout-phone">
			<p>{{ $t('common.tour.navigation.logout.phoneAction') }}</p>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
// #region Setup
import type { TourNewNavigationEmits, TourNewNavigationProps } from './TourNewNavigationSetup';
import TourNewNavigationSetup from './TourNewNavigationSetup';
const emits = defineEmits<TourNewNavigationEmits>() as TourNewNavigationEmits;
const props = withDefaults(defineProps<TourNewNavigationProps>(), TourNewNavigationSetup.defaultProps);
const setup = new TourNewNavigationSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
</style>
